import { Link } from "react-router-dom";
import StatusBadge from "@/components/base/StatusBadge";
import Timeline from "@/components/feature/Timeline";
import type { Story } from "@/mocks/stories";

export default function TimelineFeature({ story }: { story: Story }) {
  return (
    <section className="bg-background-50 py-12 md:py-20">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <p className="mb-2 flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
              <span className="block h-px w-6 bg-primary-500" aria-hidden="true" />
              事件复盘
            </p>
            <h2 className="mb-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-3xl">
              一次反转是怎么发生的
            </h2>
            <p className="mb-6 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们挑出一条已经完成反转的时间线放在这里。你能看到争议片段、节目组回应、完整收音流出与最终收束四个节点，
              以及判断是在哪一步被推翻的。这正是我们做追踪的方式——不删节点，让过程留在原地。
            </p>

            <div className="rounded-lg border border-background-300 bg-background-100 p-5">
              <div className="mb-3 flex flex-wrap items-center gap-2">
                <span className="rounded-md bg-foreground-950 px-2 py-0.5 font-label text-xs text-background-100">
                  {story.category}
                </span>
                <StatusBadge status={story.status} />
              </div>
              <h3 className="mb-2 font-heading text-base font-bold leading-snug text-foreground-950">
                {story.title}
              </h3>
              <p className="mb-4 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                {story.summary}
              </p>
              <Link
                to={`/news/${story.id}`}
                className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                阅读完整时间线
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="rounded-lg border border-background-300 bg-background-50 p-5 md:p-8">
              <div className="mb-6 flex flex-wrap items-center justify-between gap-3 border-b border-background-200 pb-4">
                <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                  完整事件时间线 · {story.timeline.length} 个节点
                </h3>
                <span className="flex items-center gap-1.5 font-label text-xs text-foreground-500">
                  <i className="ri-checkbox-circle-line text-secondary-500" />
                  已核实节点以实心色标区分
                </span>
              </div>
              <Timeline nodes={story.timeline} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}